/**
 * Static QBO sales-tax code ids (ATEK's QBO chart of tax codes).
 * HST has no static code — it is resolved at runtime and injected by the caller.
 */
export const QBO_TAX_CODE = {
    GST_QST: '9',
    GST: '6',
    QST: '10',
    GST_PST: '14',
    ZERO_RATED: '5',
};
/**
 * Place-of-supply tax profile by destination province.
 * HST provinces carry qboTaxCodeId: null until the runtime code is injected.
 * NOTE: SK and MB levy their own PST that ATEK does NOT model (ATEK is not
 * registered there). They resolve to GST-only here; a real SK/MB customer must
 * be revisited (log it, never silently mis-charge).
 */
export const PROVINCE_TAX = {
    QC: { taxType: 'GST_QST', ratePct: 14.975, components: { gst: 5, qst: 9.975 }, qboTaxCodeId: QBO_TAX_CODE.GST_QST },
    ON: { taxType: 'HST', ratePct: 13, components: { hst: 13 }, qboTaxCodeId: null },
    NB: { taxType: 'HST', ratePct: 15, components: { hst: 15 }, qboTaxCodeId: null },
    NS: { taxType: 'HST', ratePct: 15, components: { hst: 15 }, qboTaxCodeId: null },
    NL: { taxType: 'HST', ratePct: 15, components: { hst: 15 }, qboTaxCodeId: null },
    PE: { taxType: 'HST', ratePct: 15, components: { hst: 15 }, qboTaxCodeId: null },
    BC: { taxType: 'GST_PST', ratePct: 12, components: { gst: 5, pst: 7 }, qboTaxCodeId: QBO_TAX_CODE.GST_PST },
    AB: { taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
    SK: { taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
    MB: { taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
    NT: { taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
    NU: { taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
    YT: { taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST },
};
/** GST-only profile (used by customer exceptions like DND). */
export const GST_ONLY = {
    taxType: 'GST', ratePct: 5, components: { gst: 5 }, qboTaxCodeId: QBO_TAX_CODE.GST,
};
/** Indicative-only profile returned when the destination is unknown. Never post it. */
export const UNKNOWN_TAX = {
    taxType: 'GST', ratePct: 0, components: {}, qboTaxCodeId: null,
};
//# sourceMappingURL=rates.js.map